import React from 'react';
import config from '../../config';

const serverUri = config.server;

class PopupFunction4 extends React.Component {

  componentDidMount() {
    /* 결과 페이지로 돌아감 */
    setInterval(() => {
      window.open(`${serverUri}/function4/result` + this.props.location.search, 'MykeepinAuth');
      window.close();
    }, 1);
  }

  render() {
    return (<div></div>);
  }
}

// 리덕스 세팅
export default PopupFunction4;